import React from 'react';

const NewsCardSceleton: React.FC = () => {
  return (
    <div className="news-card skeleton-card">
      <div className="news-card-main">
        <div className="news-text">
          <div className="skeleton skeleton-title"></div>
          <div className="skeleton skeleton-button"></div>
        </div>
        <div className="news-image">
          <div className="skeleton skeleton-image"></div>
        </div>
      </div>
    </div>
  );
};

export default NewsCardSceleton;
